import { fromJS } from 'immutable'
import { Actions } from './fixed-templates.actions'
import * as FixedTemplatesTypes from './fixed-templates.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: [],
})

export function fixedTemplatesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case FixedTemplatesTypes.UPDATE_FIXED_TEMPLATES_REQUEST: {
      return state.set('isLoading', true)
    }

    case FixedTemplatesTypes.UPDATE_FIXED_TEMPLATES_SUCCESS: {
      return state.set('isLoading', false)
    }

    case FixedTemplatesTypes.UPDATE_FIXED_TEMPLATES_FAILURE: {
      return state.set('isLoading', false)
    }

    case FixedTemplatesTypes.FETCH_FIXED_TEMPLATES_REQUEST: {
      return state.set('isLoading', true)
    }

    case FixedTemplatesTypes.FETCH_FIXED_TEMPLATES_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case FixedTemplatesTypes.FETCH_FIXED_TEMPLATES_FAILURE: {
      return state.set('isLoading', false)
    }

    case FixedTemplatesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case FixedTemplatesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
